import ThreadPanel from './ThreadPanel';
import DailyTasksPanel from '../reminders/DailyTasksPanel';
import FilesPanel from './FilesPanel';
import ChannelSavedMessagesPanel from './ChannelSavedMessagesPanel';
import ChannelMembers from './ChannelMembers';
import ManagementMetricsPanel from './ManagementMetricsPanel';
import EventsPanel from './EventsPanel';
import CalendarPanel from './CalendarPanel';
import TeamAttendancePanel from '../attendance/TeamAttendancePanel';

// Panel registry to support a modular right side panel
const registry = {};

/**
 * Register a component to be rendered in the RightSidebar.
 * @param {string} type - The unique key identifying the panel.
 * @param {React.ComponentType} component - The React component.
 */
export const registerPanel = (type, component) => {
  registry[type] = component;
};

/**
 * Get a registered panel component.
 * @param {string} type - The unique key of the panel.
 * @returns {React.ComponentType|null} The component or null if not registered.
 */
export const getPanelComponent = (type) => {
  return registry[type] || null;
};

// Register default panels
registerPanel('thread', ThreadPanel);
registerPanel('dailyTasks', DailyTasksPanel);
registerPanel('files', FilesPanel);
registerPanel('savedMessages', ChannelSavedMessagesPanel);
registerPanel('channelDetails', ChannelMembers);
registerPanel('managementMetrics', ManagementMetricsPanel);
registerPanel('events', EventsPanel);
registerPanel('calendar', CalendarPanel);
registerPanel('teamAttendance', TeamAttendancePanel);
